<template>
  <div class="contentBox">
    <p class="title">
      {{title}}
    </p>
    <p class="text">
      {{text}}
    </p>
    <div v-html="txt"></div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      txt:'',
      title:'',
      text:''
    };
  },
  components: {
    
  },
  watch: {
    $route() {
      console.log(this,'==this==')
      window.location.reload();
    }
  },
  mounted(){
    var type = this.$route.query.type;
    if(type == 1){
      this.title = '用户协议';
      document.title = '用户协议';
      this.text = '更新时间：2024年4月';
      this.txt = "1.用户协议 <br>\
                  在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《隐私协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。本协议约定珍时信息技术（上海）有限公司（以下简称“智能演讲教练”）与用户之间关于 “子时服务”软件服务（以下简称“服务“）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由智能演讲教练随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在本APP中查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用 “智能演讲教练服务”提供的服务，用户继续使用服务将被视为接受修改后的协议。 <br>\
 <br>\
                  一、账号注册 <br>\
                  1、用户在使用本服务前需要注册一个“智能演讲教练”账号。“智能演讲教练”账号应当使用手机号码绑定注册，请用户使用尚未与“智能演讲教练”账号绑定的手机号码，以及未被服务根据本协议封禁的手机号码注册“智能演讲教练”账号。服务可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。 <br>\
                  2、“智能演讲教练”系基于 “智能演讲教练服务”的APP产品，用户注册时应当授权智能演讲教练及使用其个人信息方可成功注册“智能演讲教练”账号。故用户完成注册即表明用户同意服务提取、公开及使用用户的信息。 <br>\
                  3、鉴于“智能演讲教练”账号的绑定注册方式，您同意服务在注册时将允许您的手机号码及手机设备识别码等信息用于注册。 <br>\
                  4、在用户注册及使用本服务时，智能演讲教练需要搜集能识别用户身份的个人信息以便服务可以在必要时联系用户，或为用户提供更好的使用体验。智能演讲教练搜集的信息包括但不限于用户的姓名、地址；智能演讲教练同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。 <br>\
 <br>\
                  二、用户个人隐私信息保护 <br>\
                  1、如果智能演讲教练发现或收到他人举报或投诉用户违反本协议约定的，智能演讲教练有权不经通知随时对相关内容，包括但不限于用户资料、发贴记录进行审查、删除，并视情节轻重对违规账号处以包括但不限于警告、账号封禁 、设备封禁 、功能封禁 的处罚，且通知用户处理结果。 <br>\
                  2、因违反用户协议被封禁的用户，可以自行与智能演讲教练联系。其中，被实施功能封禁的用户会在封禁期届满后自动恢复被封禁功能。被封禁用户可提交申诉，智能演讲教练将对申诉进行审查，并自行合理判断决定是否变更处罚措施。 <br>\
                  3、用户理解并同意，智能演讲教练有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担由此而产生的一切法律责任。 <br>\
                  4、用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户应当赔偿智能演讲教练与合作公司、关联公司，并使之免受损害。 <br>\
                   <br>\
                  三、用户发布内容规范 <br>\
                  1、本条所述内容是指用户使用服务的过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于账号头像、名称、用户说明等注册信息及认证资料，或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用账号或本服务所产生的内容。 <br>\
                  2、用户不得利用“智能演讲教练”账号或本服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容： <br>\
                  (1) 反对宪法所确定的基本原则的； <br>\
                  (2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； <br>\
                  (3) 损害国家荣誉和利益的； <br>\
                  (4) 煽动民族仇恨、民族歧视，破坏民族团结的； <br>\
                  (5) 破坏国家宗教政策，宣扬邪教和封建迷信的； <br>\
                  (6) 散布谣言，扰乱社会秩序，破坏社会稳定的； <br>\
                  (7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； <br>\
                  (8) 侮辱或者诽谤他人，侵害他人合法权益的； <br>\
                  (9) 含有法律、行政法规禁止的其他内容的信息。 <br>\
                  3、用户不得利用“智能演讲教练”账号或本服务制作、上载、复制、发布、传播如下干扰“服务”正常运营，以及侵犯其他用户或第三方合法权益的内容： <br>\
                  (1) 含有任何性或性暗示的； <br>\
                  (2) 含有辱骂、恐吓、威胁内容的； <br>\
                  (3) 含有骚扰、垃圾广告、恶意信息、诱骗信息的； <br>\
                  (4) 涉及他人隐私、个人信息或资料的； <br>\
                  (5) 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的； <br>\
                  (6) 含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。 <br>\
 <br>\
                  四、分成协议 <br>\
                  智能演讲教练的发布课程需要参与创作者的收入分成的，如您使用该收费服务，请遵守相关的协议。如果您拒绝参与分成，则不能使用相关服务。 <br>\
 <br>\
                  (1) 智能演讲教练将有权决定发布课程服务的收费方式和资费标准。 <br>\
                  (2) 智能演讲教练可能根据实际需要对收费服务的收费标准、方式进行修改和变更，也可能会对部分免费服务开始收费。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。 <br>\
                  收益结算规则：作者收入=用户实际支付的费用*作者的分成比例 <br>\
                  作者的分成比例：如无特殊说明，作者分成比例是50% <br>\
                  (3) 若您在智能演讲教练平台进行课程或分享服务所获得的收益，智能演讲教练有权自行或委托第三方，包括但不限于银行、第三方支付公司等，与您进行结算 <br>\
                  (4) 智能演讲教练作为时间管理的平台，只支持兴趣爱好和时间管理的内容，不支持K12、宗教、新闻、等领域内容的课程，如果你发布了有关此方面的内容，课程将审核不通过。 <br>\
 <br>\
                  五、使用规则<br>\
                  1、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表智能演讲教练的观点、立场或政策，智能演讲教练对此不承担任何责任。<br>\
                  2、用户不得利用“智能演讲教练”账号或本服务进行如下行为：<br>\
                  (1) 提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的；<br>\
                  (2) 强制、诱导其他用户关注、点击链接页面或分享信息的；<br>\
                  (3) 虚构事实、隐瞒真相以误导、欺骗他人的；<br>\
                  (4) 利用技术手段批量建立虚假账号的；<br>\
                  (5) 利用“智能演讲教练”账号或本服务从事任何违法犯罪活动的；<br>\
                  (6) 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；<br>\
                  (7) 其他违反法律法规规定、侵犯其他用户合法权益、干扰“智能演讲教练”正常运营或服务未明示授权的行为。<br>\
                  3、用户须对利用“智能演讲教练”账号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与智能演讲教练无关。 如因此给智能演讲教练或第三方造成损害的，用户应当依法予以赔偿。<br>\
                  4、智能演讲教练提供的服务中可能包括广告，用户同意在使用过程中显示智能演讲教练和第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责， 对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，智能演讲教练不承担任何责任。<br>\
<br>\
                  六、其他<br>\
                  1、智能演讲教练郑重提醒用户注意本协议中免除智能演讲教练责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。<br>\
                  2、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和智能演讲教练之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交智能演讲教练住所地有管辖权的人民法院管辖。<br>\
                  3、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。<br>\
                  本《协议》版权由智能演讲教练所有，智能演讲教练保留一切对本《协议》解释的权利。"
    } else if(type == 2){
      this.title = '隐私政策';
      document.title = '隐私政策';
      this.text = '更新时间：2025年5月';
      this.txt = "生效日期：2022年05月22日<br>\
                  “智能演讲教练”指珍时信息技术（上海）有限公司（以下简称“我们”）合法拥有并运营的、标注名称为智能演讲教练的客户端应用程序。 我们作为智能演讲教练的运营者，深知个人信息对你的重要性，我们将按照法律法规的规定，保护你的个人信息及隐私安全。 我们制定本隐私政策并特别提示：希望你在使用智能演讲教练及相关服务前仔细阅读并理解本隐私政策，以便作出适当的选择。<br>\
<br>\
                  概要<br>\
<br>\
                  我们将通过本隐私政策向你介绍我们如何处理个人信息。 当你开启或使用智能演讲教练时，为实现你选择使用的功能、服务，或为遵守法律法规的要求，我们会处理相关信息。 除实现智能演讲教练基本功能、服务所需的信息，和根据法律法规要求所必需的信息之外，你可以拒绝我们处理其他信息，但这可能导致我们无法提供对应功能、服务。 我们将在隐私政策中逐项说明相关情况，有关你个人信息权益的重要条款已用加粗形式提示，请特别关注。<br>\
<br>\
                  智能演讲教练除本隐私政策外，在特定场景下，我们还会通过即时告知（含弹窗、页面提示等）、功能更新说明等方式，向你说明对应的信息收集目的、范围及使用方式，这些即时告知及功能更新说明等构成本隐私政策的一部分，并与本隐私政策具有同等效力。 下文将帮你详细了解我们如何收集、使用、存储、传输、公开与保护个人信息；帮你了解查询、更正、补充、删除、复制、转移个人信息的方式。 其中，有关你个人信息权益的重要内容已用加粗形式提示，请特别关注。<br>\
<br>\
                  <a href='#/agreement?type=5'>第三方信息共享清单</a><br>\
                  <br>\
                  1.我们如何收集和使用个人信息<br>\
                  2.数据使用过程中涉及的合作方以及转移、公开个人信息<br>\
                  3.管理你的个人信息<br>\
                  4.我们如何保护个人信息的安全<br>\
                  5.我们如何存储个人信息<br>\
                  6.我们如何保护未成年人<br>\
                  7.隐私政策的查阅和修订<br>\
                  8.联系我们<br>\
                  <br>\
                  1 我们如何收集和使用个人信息<br>\
                  <br>\
                  1.1 帐号服务<br>\
                  <br>\
                  1.1.1 注册、登录<br>\
                  <br>\
                  当你注册、登录智能演讲教练及使用相关服务时，你可以通过手机号码创建帐号，并且你可以完善相关的网络身份识别信息（头像、昵称、密码），我们收集这些信息是为了帮助你完成注册。 收集手机号码是履行国家法律法规关于网络实名制（真实身份信息认证）要求的必要信息，基于我们与通信运营商的合作，当你使用“一键登录”功能时，经过你的同意，我们会使用运营商提供的功能，将你设备中的手机号码作为你的注册、登录帐号并免于密码或动态验证码核验，为你提供快捷的注册、登录服务。 如果你不希望使用“一键登录”功能，可以通过其他方式注册、登录智能演讲教练。 如果你忘记了你的智能演讲教练的登录方式，可以使用找回密码功能。 为保障你帐号的安全，我们可能需要你填写相关信息以进行验证，必要时可能通过真实身份信息验证等方式验证你的身份。<br>\
                  <br>\
                  1.1.2 帐号公开信息<br>\
                  <br>\
                  你可以自主填写性别、生日、地区及个人介绍来完善你的信息。 不填写信息不会影响你使用智能演讲教练帐号及服务。<br>\
                  <br>\
                  1.2 内容浏览<br>\
                  <br>\
                  在你使用智能演讲教练内容的过程中，我们会记录你的使用情况。 如果你未登录帐号，我们会通过设备对应的标识符信息来记录你的【点击、浏览、分享信息】。 如果你已登录帐号，我们会通过你的智能演讲教练帐号记录你的【点击、浏览、分享等】。<br>\
                  <br>\
                  1.3 信息发布<br>\
                  1.3.1 音视频、图文<br>\
                  <br>\
                  当你上传演讲音视频或图片以进行 AI 分析、评分及相关操作时，我们会根据你使用的功能类型分别请求你授权相机、相册、麦克风权限。如你拒绝授权，将无法使用相关的拍摄与音视频分析功能，但不影响你使用智能演讲教练的其他功能。 我们非常重视用户的使用体验，为了提升音视频的上传速度和优化体验，当你拍摄并上传音视频时，在拍摄完成点击确认上传之前，我们会将该音视频临时加载至服务器。 如果你取消或因其他原因未成功上传，我们会立即删除相关音视频。<br>\
                  <br>\
                  1.4运营与安全运行<br>\
                  <br>\
                  我们致力于为你提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。 为了维护相关产品或服务的正常稳定运行，保护你或其他用户或公众的安全及合法利益，我们会收集如下必要信息：<br>\
                  <br>\
                  <span class='blod'>（1）为了保障软件与服务的安全运行、运营的质量及效率，当您使用我们的服务时（包括后台运行和静默状态）,我们会收集你的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、硬件序列号、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息数据、软件安装列表、位置、联系人、通话记录、日历、短信、本机电话号码、图片、音视频等个人信息。</span><br>\
                  <span class='blod'>（2）为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</span><br>\
                  <span class='blod'>（3）我们可能使用你的帐号信息、设备信息、服务日志信息，以及我们的关联方、合作方获得你授权或依法可以提供给我们的信息，用于判断帐号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</span><br>\
                  <span class='blod'>（4）为了保障软件图片显示存储，我们在应用内集成七牛云com.qiniu(七牛;PLPlayerkit;PLShortVideoKit;Qiniu)SDK，帮助您展示图片并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（5）为了保障软件分享第三方应用，我们在应用内集成友盟com.umeng.umsdk(common,asms,apm，link，Utdid) SDK，帮助您能分享内容并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（6）为了保障软件购买产品，我们在应用内集成支付宝com.alipay(支付宝;mPaaS;阿里乘车码;阿里芝麻信用实名认证;芝麻认证)】等SDK，帮助您能支付购买产品并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（7）为了保障软件购买产品及微信登录，我们在应用内集成微信com.tencent.mm.opensdk（授权登录，微信支付）SDK，帮助您能支付购买及微信登录并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（8）为了保障软件购买产品及电信天翼一键登录，我们在应用内集成中国电信cn.com.chinatelecom(电信;中国电信;天翼)SDK，帮助您能实现一键登录并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（9）为了保障软件购买产品及语音输入，我们在应用内集成科大讯飞语音com.iflytek.cloud(科大讯飞语音听写)SDK，帮助您能实现Ai语音输入并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（10）为了保障软件购买产品及视频播放，我们在应用内集成阿里云sdk,com.ta.utdid2(阿里播放器)SDK，帮助您能实现视频播放并不会泄露您的个人信息。</span><br>\
                  <span class='blod'>（11）为了保障软件购买产品，我们在应用内集成腾讯com.tencent.cloud.soe口语评测SDK，帮助您实现口语发音训练并不会泄露您的个人信息</span><br>\
                  <span class='blod'>（12）为了保障软件购买产品，我们在应用内集成com.ss.bytertc.engine火山实时音视频SDK，帮助您更流畅的语AI进行对话并不会泄露您的个人信息</span><br>\
                  <span class='blod'>（13）为了实现对用户行为进行统计（包括后台运行和静默状态）、并实现精细化行为数据分析，帮助开发者实现精细化运营，我们集成了百度移动统计【com.baidu.mobstat】SDK，并不会泄露您的个人信息，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用智能演讲教练APP服务。</span><br>\
                  <span class='blod'>（14）为了保障软件的核心 AI 交互功能（如智能演讲大纲生成、AI 问答对练、文稿深度分析等），我们在应用内接入了第三方人工智能（AI）大模型应用程序接口（API）。当您触发相关 AI 功能时，我们会收集您的输入文稿、文本指令或转换为文本的语音数据，并发送至我们的合作方（包括：深度求索 DeepSeek、阿里云通义千问、字节跳动豆包）。我们收集并传输这些信息是为了向您提供智能化的演讲辅导服务，不会泄露您的个人信息。</span><br>\
                  <br>\
                  1.5 Cookie等同类技术的使用<br>\
                  <br>\
                  Cookie 和设备信息标识等同类技术是互联网中普遍使用的技术。当你使用智能演讲教练及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个Cookie 或匿名标识符，以收集、标识你访问、使用本产品时的信息。我们承诺，不会将Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie 和同类技术主要为了实现以下功能或服务：<br>\
                  保障产品与服务的安全、高效运转：我们可能会设置认证与保障安全性的Cookie 或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br>\
                  帮助你获得更轻松的访问体验：使用此类技术可以帮助你省去重复填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。<br>\
                  在智能演讲教练的分享页中，我们可能会使用Cookie对浏览活动进行记录，用于向你推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。<br>\
                  Cookie的清除 ：如你使用智能演讲教练网页版，大多数浏览器均为用户提供了清除浏览器缓存数据的功能，你可以在浏览器设置中操作清除Cookie数据，但清除后可能无法使用由我们提供的、依赖于Cookie的功能或服务。<br>\
                  <br>\
                  1.6 服务内容的变更<br>\
                  <br>\
                  请你了解，随着我们业务的发展，可能会调整智能演讲教练提供的产品或服务。如调整变化后的产品或服务所处理个人信息的目的、方式和范围发生变化的，我们会再次向你告知，并根据法律法规的相关要求征得你的同意。<br>\
                  <br>\
                  1.7依法豁免征得同意处理个人信息<br>\
                  <br>\
                  请你理解，在下列情形中，根据法律法规，我们处理你的个人信息无需征得你的授权同意。<br>\
                  a) 根据你的要求订立或履行合同所必需；<br>\
                  b) 为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br>\
                  c) 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br>\
                  d) 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br>\
                  e) 在合理的范围内处理你自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br>\
                  f) 法律法规规定的其他情形。<br>\
                  特别说明：根据法律规定，如信息无法单独或结合其他信息识别到特定个人的，其不属于个人信息。当你的信息可以单独或结合其他信息识别到你时，或我们把没有与任何特定个人建立联系的数据与你的个人信息结合使用时，我们会将其作为你的个人信息，按照本隐私政策进行处理与保护。<br>\
                  <br>\
                  2 数据使用过程中涉及的合作方以及转移、公开个人信息<br>\
                  2.1 数据使用过程中涉及的合作方<br>\
                  2.1.1基本原则<br>\
                  我们与合作方合作过程中，将遵守以下原则：<br>\
                  a) 合法原则：涉及数据处理活动的，应当遵守合法原则。<br>\
                  b) 正当与最小必要原则：数据使用必须具有正当目的，且应以达成目的必要为限。<br>\
                  c) 安全审慎原则： 我们将审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。<br>\
                  <br>\
                  2.1.2 委托处理<br>\
                  对于委托处理个人信息的场景，我们会与受托合作方根据法律规定签署相关处理协议，并对其个人信息使用活动进行监督。<br>\
                  <br>\
                  2.1.3共同处理<br>\
                  对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。<br>\
                  <br>\
                  2.1.4 合作方的范围<br>\
                  若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。<br>\
                  <br>\
                  2.2 合作的场景<br>\
                  2.2.1 为实现智能演讲教练的业务功能<br>\
                  a) 消息通知：为与你使用的终端机型适配消息推送功能，终端设备制造商（华为、小米、OPPO、VIVO等）可能通过SDK等技术使用你的手机型号、版本及相关设备信息。<br>\
                  b) 登录、绑定其他第三方帐号：当你使用智能演讲教练帐号登录其他第三方的产品或服务时，或将智能演讲教练帐号与其他第三方帐号绑定时，经过你的同意，上述第三方的产品或服务将会使用你的昵称、头像及其他你授权的信息。<br>\
                  c) 客户服务：为及时处理你的投诉、建议以及其他诉求，客户服务提供商需要使用你的帐号及相关信息，以及时了解、处理和响应你的需求。如有必要，也可能需要使用你的手机号码或通过其他通讯方式与你取得联系。<br>\
                  d) 支付服务：支付功能由与我们合作的第三方支付机构向你提供服务。第三方支付机构可能需要收集你的姓名、身份证号、银行卡类型及卡号、有效期及手机号码。身份证号和银行卡相关信息是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致你无法使用该功能，但不影响其他功能的正常使用。<br>\
                  <br>\
                  2.2.2 实现安全与统计分析<br>\
                  a) 保障使用安全：我们非常重视产品和服务的安全性，为保障智能演讲教练用户的正当合法权益免受不法侵害，我们的合作方可能会使用必要的设备、帐号及日志信息。<br>\
                  b）分析产品情况：为分析智能演讲教练的产品和服务的稳定性，提供分析服务的合作方可能需要使用服务情况（崩溃、闪退记录）、设备标识信息、应用总体安装使用情况等信息。<br>\
                  <br>\
                  2.2.3 涉及第三方人工智能（AI）服务的共享<br>\
                  当你使用智能生成、AI 互动与评估功能时，为了实现前述业务功能，我们需要向第三方 AI 服务商（包括：深度求索 DeepSeek、阿里云通义千问、字节跳动豆包）共享你的文本输入内容及语音数据。针对此场景，我们郑重向你承诺并声明：<br>\
                  <br>\
                  2.3 运营主体变更<br>\
                  随着业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护你的个人信息，继受方变更原先的处理目的、处理方式的，我们将要求继受方重新征得你的授权同意。<br>\
                  <br>\
                  2.4 停止运营<br>\
                  如果我们停止运营产品或服务，将及时停止继续收集你的个人信息。我们会逐一送达通知或以公告的形式向你发送停止运营的告知，并对我们所持有的与已关停的产品或服务相关的个人信息进行删除或匿名化处理。<br>\
                  <br>\
                  2.5 公开<br>\
                  我们不会主动公开你未自行公开的信息，除非遵循国家法律法规规定或者获得你的同意。<br>\
                  <br>\
                  2.6 依法豁免征得你的授权同意的情形<br>\
                  请你理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开你的个人信息无需征得你的授权同意：<br>\
                  a) 根据你的要求订立或履行合同所必需；<br>\
                  b) 为履行法定职责或者法定义务所必需，例如与国家安全、国防安全、与刑事侦查、起诉、审判和判决执行等直接相关的法定职责或者法定义务；<br>\
                  c) 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；<br>\
                  d) 为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；<br>\
                  e) 在合理的范围内处理你自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）；<br>\
                  f) 法律法规规定的其他情形。<br>\
                  <br>\
                  3 管理你的个人信息<br>\
                  我们非常重视你对个人信息的管理，并尽全力保护你对于你个人信息的查阅、复制、更正、补充、删除、撤回同意授权、注销帐号、投诉举报等权利，以使你有能力了解并保障你的个人信息安全。<br>\
                  但请你理解，特定的业务功能和服务将需要你的信息才能得以完成，当你撤回同意或授权后，我们无法继续为你提供对应的功能和服务，也不再处理你相应的个人信息。但你撤回同意或授权的决定，不会影响我们此前基于你的授权而开展的个人信息处理。<br>\
                  我们在不同的版本或操作系统中提供的管理方式的路径可能有差异，请以实际为准。<br>\
                  <br>\
                  3.1 设置管理<br>\
                  3.1.1 系统权限设置<br>\
                  a) 你可以在设备中的设置功能中开启或关闭地理位置、通讯录、摄像头、麦克风、相册、日历等权限，改变授权范围或撤回你的授权。撤回授权后我们将不再收集与这些权限相关的信息，但不会影响我们此前基于你的授权而开展的个人信息处理。你可以阅读智能演讲教练权限申请与使用情况说明，以了解智能演讲教练申请和使用系统权限的情况。<br>\
                  b) 你可以在设备的设置中选择是否接收智能演讲教练发送的系统通知，或设置你希望接收的系统通知的形态。<br>\
                  <br>\
                  3.2 访问、更正和补充您的个人信息<br>\
                  a) 访问、更正和补充头像、我的相册、我的动态、个人证件信息：<br>\
                  APP端： 登录账号后，点击“我的”；点击头像栏，进行信息访问、更正和补充。<br>\
                  b) 访问、更正手机号、登录密码账户信息<br>\
                  APP端： 登录账号后，点击“我的”；点击“设置”，进行信息访问、更正。<br>\
                  <br>\
                  3.3 复制、转移你的个人信息<br>\
                  如果你需要复制我们收集存储的个人信息，你可以通过8.1条列出的联系方式与我们联系。<br>\
                  如果你需要转移我们收集存储的个人信息，我们将根据法律法规的要求，为你提供转移路径。<br>\
                  <br>\
                  3.4 帐号注销<br>\
                  你可以在【我】-【设置】-【注销帐号】进行帐号注销。在你注销帐号前，我们将验证你已授权给我们的个人身份、安全状态、设备信息等。你知悉并理解，注销帐号的行为是不可逆的行为，当你注销帐号后，我们将删除有关你的相关信息，若删除个人信息从技术上难以实现的，我们会进行匿名化处理，或停止除存储和采取必要的安全保护措施之外的处理，但法律法规另有规定的除外。<br>\
                  除上述外，如果你或其他有权主体对相关法律法规赋予的个人信息权利的行使，有任何主张、要求或者疑问，你可以在【我-【设置】-【联系我们】，进入用户反馈界面与我们联系，我们将尽快审核所涉问题，并在验证你的用户身份后的十五个工作日内回复。<br>\
                  <br>\
                  4 我们如何保护个人信息的安全<br>\
                  我们非常重视你的个人信息安全，将努力采取合理的安全措施来保护你的个人信息，确保我们的个人信息处理活动符合法律、行政法规或依法可适用的其他制度的要求，并防止未经授权的访问以及个人信息泄露、篡改、丢失。<br>\
                  <br>\
                  4.1 安全技术措施<br>\
                  我们会使用不低于行业通常水平的加密、去标识化技术、匿名化处理及相关合理可行的手段保护你的个人信息，并使用安全保护机制防止你的个人信息遭到恶意攻击。<br>\
                  <br>\
                  4.2 管理制度<br>\
                  我们会建立专门的安全部门、安全管理制度、数据安全流程保障你的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问你的个人信息。我们会定期对人员进行安全教育和培训，并适时对数据和技术进行安全审计。<br>\
                  我们会制定并组织实施个人信息安全事件应急预案，并在发生个人信息安全事件时立即启动应急预案，努力控制这些安全事件的影响，防止不利后果扩大。一旦发生或可能发生个人信息安全事件（泄露、篡改、丢失）的，我们将按照法律法规的要求，及时向你告知以下情况：发生或者可能发生泄露、篡改、丢失的个人信息种类、原因和可能造成的危害，我们已采取的补救措施，你可以采取的减轻危害的措施以及与我们联系的方式。<br>\
                  我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知你，难以逐一告知时，我们会采取合理、有效的方式发布公告。<br>\
                  同时，我们还将按照相关监管部门要求，上报个人信息安全事件的处置情况。<br>\
                  <br>\
                  4.3 安全提示<br>\
                  尽管已经采取了上述合理有效措施，并已经遵守了相关法律法规要求的标准，但请你理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保你提供给我们的个人信息的安全性。<br>\
                  你知悉并理解，你接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。<br>\
                  你一旦离开智能演讲教练，浏览或使用第三方提供的其他产品或服务，我们将没有能力和直接义务保护你向第三方提交的任何个人信息，无论你登录、浏览或使用上述产品或服务是否基于智能演讲教练的链接或引导。但我们会提示你注意将进入第三方产品或服务，以便你更好地保护你的个人信息。<br>\
                  <br>\
                  5 我们如何存储个人信息<br>\
                  5.1 存储地点<br>\
                  我们依照法律法规的规定，将在中华人民共和国境内运营过程中收集和产生的你的个人信息存储于境内。我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求你的同意。<br>\
                  <br>\
                  5.2 存储期限<br>\
                  a) 我们仅会在为你提供智能演讲教练产品或服务所必需的期间内保留你的个人信息，例如：<br>\
                  手机号码：当你使用手机号码注册登录后，我们需要持续保留你的手机号码，以便于向你提供正常的服务、应对你可能的查询和客诉并保障你的帐号和系统安全。<br>\
                  你发布的内容及相关信息，在你未删除或未注销帐号之前，我们会予以保留用于向你提供持续的业务功能。<br>\
                  b) 如果你注销帐号、主动删除个人信息或信息超出必要的保存期限后，我们将对你的个人信息进行删除或匿名化处理，但以下情况除外：<br>\
                  遵从法律法规有关信息留存的要求（例如：《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。<br>\
                  出于财务、审计、争议解决等目的需要合理延长期限的。<br>\
                  <br>\
                  6 我们如何保护未成年人<br>\
                  6.1 未成年人通用条款<br>\
                  a) 若你是未满18周岁的未成年人，在使用智能演讲教练及相关服务前，应在你的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。<br>\
                  b) 若你是未满14周岁的未成年人的监护人，在使用智能演讲教练及相关服务前，应为你的被监护人阅读并同意本隐私政策。<br>\
                  c) 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息。如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。<br>\
                  d) 若你是未成年人的监护人，当你对你所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。<br>\
                  <br>\
                  7 隐私政策的查阅和修订<br>\
                  7.1 查阅<br>\
                  a.你可以在注册登录页面，或者登录帐号后在【我】-【设置】- 【隐私政策】页面查看本隐私政策。<br>\
                  b.请你了解，为了满足运营需要，我们可能会根据你所使用的手机型号、系统版本、移动客户端等因素开发不同的版本，因此在你使用特定版本时，智能演讲教练的功能可能与本隐私政策描述的有所区别，但不会影响数据处理的目的、方式和范围，具体可用功能以你实际使用的情况为准。<br>\
                  <br>\
                  7.2 更新及通知<br>\
                  a.为了给你提供更好的服务，智能演讲教练产品和服务将不时更新与变化，我们会适时对本隐私政策进行修订。未经你明确同意，我们不会削减你依据当前生效的隐私政策所应享受的权利。<br>\
                  b.本隐私政策更新后，我们会在智能演讲教练发出更新版本，并通过站内信或其他适当的方式提醒你更新的内容，以便你及时了解本隐私政策的最新版本。<br>\
                  c.我们也可能通过功能更新，帮助你更好地管理你的个人信息，请你留意相关的功能说明。<br>\
                  <br>\
                  8 联系我们<br>\
                  8.1 投诉与举报<br>\
                  如果你认为你的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，你可以在【我】-【-【设置】-【联系客服】，与我们联系。<br>\
                  我们核查后会在十五个工作日内反馈你的投诉与举报。<br>\
                  <br>\
                  8.2 其他问题<br>\
                  如果你对个人信息保护问题有疑问或建议，可选择通过以下方式联系我们：<br>\
                  a)  您可以拨打客服电话021-5889 0020与我们联系；<br>\
                  3）您可以写信至：上海市浦东新区浦东三林软件园1号楼702室；<br>\
                  我们将尽快审核你提出的问题或建议，并在验证你的用户身份后的十五个工作日内回复。"
    } else if(type == 3){
      this.title = '智能演讲教练会员服务协议';
      document.title = '智能演讲教练会员服务协议';
      this.text = '生效时间：2025-4 发布时间：2025-4';
      this.txt = "感谢您使用【智能演讲教练】会员增值服务，为使用【智能演讲教练】会员增值服务（简称为：本服务）， <br>\
                  您应当阅读并遵守《智能演讲教练会员服务协议》（简称为：本协议）。 <br>\
                  请您务必审慎阅读、充分理解各条款内容，特别是免除或限制责任等相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。 <br>\
                  免除或限制责任条款可能以加粗形式提示您注意。 <br>\
                  未成年人应在法定监护人陪同下审阅和履行本协议，未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。 <br>\
                  一、协议的范围<br>\
                  1.1 协议适用主体范围<br>\
                  本协议是您与智能演讲教练信息技术（上海）有限公司之间关于您使用本增值服务所订立的协议。<br>\
                  1.2 您同意本协议即视为您自愿接受并遵守智能演讲教练提供服务涉及的包括本协议在内的所有服务规范及相关协议、管理规范，包括但不限于智能演讲教练不时发布并修订的关于智能演讲教练服务协议、隐私政策、会员相关协议、活动规则、使用规则、公告、提示、通知等内容。<br>\
                  二、服务内容<br>\
                  2.1 会员增值服务，指您按照智能演讲教练的指定方式支付一定服务费用之后，可以享有由智能演讲教练提供的的特权服务，简称为：本服务。<br>\
                  2.2 智能演讲教练可能会根据不同的产品及服务类型，推出不同的会员增值服务，对现有会员增值服务种类、会员权益等进行调整以及不断推出新的会员增值服务种类。具体会员增值服务种类及服务内容以相关服务页面公布、实际提供的服务内容为准，并在公告后依法生效。您可以自行根据需要选择相应服务。<br>\
                  2.3 关于广告的特别说明：您在使用智能演讲教练会员服务的过程中，将接触到以各种方式投放的商业性广告或其他类型的商业信息，智能演讲教练会提供“免广告特权”,“免广告特权”的范围仅指在智能演讲教练中带有“广告”标识的内容，不含第三方信息资讯等内容。广告特权包括为您自动跳过广告，也可手动关闭内容推荐；但此权益可能因版权方限制或其他限制原因，仍可能会向您呈现不同种类的广告服务，且亦不排除智能演讲教练以其他方式投放的广告或商业信息。对此您理解并予以接受，您不追究并豁免智能演讲教练的相关责任，同时智能演讲教练承诺会尽量降低对您的使用体验影响。<br>\
                  三、会员费用及期限<br>\
                  3.1 费用标准及支付<br>\
                  3.1.1 本服务是智能演讲教练提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。<br>\
                  3.1.2 智能演讲教练可能会根据本服务的整体规划，对本服务的收费标准、方式等进行修改和变更，前述修改、变更，智能演讲教练将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等信息。您的开通以及支付行为视为您完全清楚智能演讲教练提供收费服务的收费标准以及方式。<br>\
                  3.1.3 您可以通过智能演讲教练指定的包括但不限于微信支付、支付宝、Apple Pay等现有方式、今后智能演讲教练指定方式在依约支付费用后开通本服务。<br>\
                  3.1.4 智能演讲教练在此声明，您支付后智能演讲教练不接受任何形式的退费请求，除非因智能演讲教练产品技术原因，导致您购买时被重复扣款或因智能演讲教练产品技术原因导致您无法享有购买的服务时，请您在7日内提出退款申诉，经过智能演讲教练核实后可为您办理退款，但您需要提供相应信息并配合智能演讲教练处理,如您未在前述约定期限提出申诉，智能演讲教练视为您购买产品/服务无任何问题。您理解并清楚接受上述条件，如您不接受的，请谨慎选择收费服务。<br>\
                  3.2 服务期限<br>\
                  3.2.1 本服务的服务期限以您自行选择并支付相应服务费用的期限为准，本服务现有包月、包半年、包年服务，您也可以登录智能演讲教练个人中心或者本服务的相应页面查询。会员服务的服务期限到期后，智能演讲教练将停止继续向您提供会员服务，服务期限届满前智能演讲教练可能会提醒您及时续费。<br>\
                  3.2.2 如您希望享受会员服务连续采购和自动扣费的服务，您可以根据操作指引向智能演讲教练提出申请，并在仔细阅读《智能演讲教练会员自动续费服务协议》后决定是否继续申请。<br>\
                  四、会员服务的开通、账号管理及注销<br>\
                  4.1 您通过智能演讲教练指定的方式依约支付费用后即开通本服务。本服务开通之后，仅限于您在智能演讲教练平台使用，不及于其他任何平台，未经智能演讲教练书面同意不可提供给任何第三方进行使用，包括但不限于赠与、出售、租用、借用、分享、受让等方式。<br>\
                  4.2 会员账号的管理<br>\
                  （1）您充分了解并同意，您须为自己登录账号下的行为负责，本账号下的一切行为均视为您本人的行为，包括但不限于您所发表的任何内容以及由此产生的后果，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。您应对本服务提供的内容自行加以判断，并承担因使用相关内容而引起的风险。<br>\
                  （2）您应正确使用及妥善保管、维护您的会员账号及密码，如发生泄露、遗失、被盗等行为，而该等行为并非智能演讲教练法定过错导致，损失将由您自行承担。<br>\
                  （3）会员服务仅限于申请账号自行使用；每个账号之间的充值记录、数据无法进行转移、迁徙、转让、赠与、售卖、租借、分享，无论该等账号是否由同一使用人拥有，请您在登录及/或参加活动时注意区分，避免造成损失。<br>\
                  4.3 账号的使用<br>\
                  您不得通过以下任何方式为自己或他人开通本服务：<br>\
                  （1）以营利、经营等非个人使用的目的为自己或他人开通本服务；<br>\
                  （2）通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式为自己或他人开通本服务；<br>\
                  （3）通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通本服务；<br>\
                  （4）通过非智能演讲教练指定的方式开通本服务；<br>\
                  （5）通过侵犯智能演讲教练或他人合法权益的方式开通本服务；<br>\
                  （6）通过其他违反相关法律、行政法规、国家政策等的方式为自己或他人开通本服务。<br>\
                  您理解并同意：若您存在以上行为智能演讲教练有权采取相应措施（包括但不限于未经通知即关闭服务、要求您赔偿智能演讲教练因此遭受的全部损失以及提请司法机关追究法律责任）追究您的相关责任。<br>\
                  4.4 会员账号注销：除智能演讲教练按照协议或公告及相关法律法规注销用户的会员账号外，您可以通过在线申请或联系智能演讲教练的客服等方式注销会员账号。您确认账号一旦注销，您将无法继续使用会员服务。且您曾通过该账号使用相关服务所涉及的所有内容、信息、数据、记录将会被删除或匿名化处理；除法律法规另有规定，您也无法再检索、访问、获取、继续使用和找回前述内容、信息、数据、记录，也无权要求智能演讲教练找回。<br>\
                  五、会员行为规范<br>\
                  5.1 您在使用本服务时不得利用本服务从事以下行为，包括但不限于：<br>\
                  （1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；<br>\
                  （2）发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；<br>\
                  （3）虚构事实、隐瞒真相以误导、欺骗他人；<br>\
                  （4）发表、传送、传播广告信息及垃圾信息；<br>\
                  （5）从事其他违反法律法规（包括但不限于《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规）、政策及公序良俗、社会公德等的行为。<br>\
                  5.2 本服务仅供您个人使用，除非经智能演讲教练书面许可，您不得进行以下行为：<br>\
                  （1）通过任何方式搜集本服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；<br>\
                  （2）通过本服务发布包含广告、宣传、促销等内容的信息；<br>\
                  （3）将本服务再次许可他人使用；<br>\
                  （4）其他未经智能演讲教练书面许可的行为。<br>\
                  5.3 服务的变更、中止或终止<br>\
                  5.3.1 本服务的中止或终止包含如下情况：<br>\
                  （1）您主动中止或终止，包括但不限于会员到期未进行续费等；<br>\
                  （2）因为您的违约行为，智能演讲教练主动中止或终止服务的；<br>\
                  （3）因国家或相关政府监管部门要求或发生不可抗力事件时，智能演讲教练中止或终止服务的；<br>\
                  （4）其他根据法律法规应中止或终止服务的。<br>\
                  5.3.2 您充分了解并同意，由于互联网服务的特殊性，智能演讲教练可能会按照相关法律法规、双方约定或在其他必要时，修改、变更、中止或终止向您提供部分或全部服务，届时，智能演讲教练会依法保护您的合法权益。且您同意，依本服务协议规定提供之服务，无需进行事先通知即可变更、中止或终止，针对变更服务，如果您继续使用，即视为您同意该变更。本条记载的情形下不视为智能演讲教练违约，智能演讲教练无需向您承担任何法律责任。<br>\
                  5.3.3 智能演讲教练未及时行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其他权利的行使。<br>\
                  六、违约责任<br>\
                  6.1 违约的处理<br>\
                  如果智能演讲教练发现或收到他人举报您有任何违反本协议的行为，智能演讲教练有权依法进行独立判断并采取技术手段予以删除、屏蔽或断开相关的信息。同时，智能演讲教练有权视您的行为性质，对您采取包括但不限于中止或终止部分或全部本服务、中止或终止您对智能演讲教练会员使用、追究您法律责任等措施，智能演讲教练也无需向您退还任何费用，而由此给您带来的损失，由您自行承担，造成智能演讲教练损失的，您也应予以赔偿（包括但不限于直接经济损失、商誉损失及对外支付的赔偿金、和解费、律师费、诉讼费等合理费用），并且在智能演讲教练要求的时限内支付完毕。<br>\
                  6.2 对第三方损害的处理<br>\
                  您有违反本协议约定的任何行为，导致任何第三方损害的，您应当独立承担责任；智能演讲教练因此遭受损失的，您也应当进行赔偿。<br>\
                  七、其他<br>\
                  7.1 协议的生效<br>\
                  您使用本服务即视为您已阅读并同意受本协议的约束。除本协议另有约定情况外，本协议自您选择接受或使用本服务后生效，直至终止本服务时止。<br>\
                  7.2 适用法律<br>\
                  本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。<br>\
                  7.3 争议解决<br>\
                  若您和【智能演讲教练】之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交有管辖权的人民法院管辖。<br>\
                  7.4 条款效力<br>\
                  本协议条款无论因何种原因部分无效或不可执行，不影响其余条款的效力及执行，对双方具有约束力。<br>\
                  （正文完）<br>\
                  智能演讲教练信息技术（上海）有限公司"
    }else if(type == 4){
      this.title = '智能演讲教练会员服务自动续费协议';
      document.title = '智能演讲教练会员服务自动续费协议';
      this.text = '更新日期2025.4';
      this.txt = "请您务必审慎阅读，充分理解本协议各条款内容，特别免除或限制责任的相应条款。将以加粗或斜体标注等形式提醒您着重注意限制与相应条款。 <br>\
                  当您选择开通自动续费功能，视为您以阅读并同意接受本协议内容。如果您对本协议内容表示异议，您可以选择不开通本功能。<br>\
                  开通自动续费服务<br>\
                  1、自动续费服务是在您已开通智能演讲教练会员服务的前提下，为您提供的自动续费服务。如您开通本服务，则视为在您购买的连续订阅服务即将到期时， <strong>从您的苹果账户（包括但不限于Apple ID/iTunes等）余额中代扣下一个服务周期的服务费， 服务周期包括但不限于1周、1个月、3个月、1年等（具体以您实际选择的服务周期为准）</strong>。 <br>\
                  <strong>2、在开通自动续费服务后，我们将在您购买的服务到期前24小时内，自动扣除下一期费用，并自动延续相应的服务内容、服务条件与服务期限。 </strong><br>\
                  3、如因非可归因为智能演讲教练的原因 （如苹果服务器问题、网络问题、第三方系统故障、自动扣费账户余额不足等） 造成自动续费失败，我们将按照「到期未续费」处理，停止向您提供相应服务。由此产生的不利后果由您自行承担。 <br>\
                  * 特别提示，当您的智能演讲教练账号开通自动续费后，该账号将与您的苹果账户所绑定。绑定后该苹果账号所购买的自动扣费服务只会对绑定智能演讲教练账号生效。如您登陆其他智能演讲教练账号，并使用同一苹果账号购买自动扣费服务时，所购买的服务将生效到该苹果账号所绑定的黄油账号中。 <br>\
                  （例如您使用「苹果账号A」为「智能演讲教练账号a」开通自动续费会员服务并绑定后，当您使用同一「苹果账号A」再为「智能演讲教练账号b」开通自动续费会员时，所购买的会员或服务仍将在「黄油账号a」中生效）。<br>\
                  关闭自动续费<br>\
                  1、您可以从第三方支付账户（或系统）中关闭自动续费功能。关闭路径如下：<br>\
                  苹果设备：苹果应用内支付（IAP支付，in-app purchase）自动续费：打开苹果手机「设置」 --> 进入「iTunes Store 与 App Store」--> 点击「Apple ID」，选择「查看 Apple ID」，进入「账户设置」页面，点击「订阅/订阅管理」，选择智能演讲教练会员取消订阅即可。 <br>\
                  <strong>2、关闭本功能视为您撤销自动扣费的授权，但此撤销行为不会影响撤销前已完成的扣款。</strong><br>\
                  账号独立<br>\
                  1、同一主体拥有多个智能演讲教练账号时，每一个智能演讲教练账号将被视为一个独立的账号； <br>\
                  <strong>2、每个账号之间的会员状态、权益与有效期独立，无法转让、共享、赠予、售卖、租赁、分享，无论该账号是否由同一主体拥有。请您再购买会员服务或开通自动续费服务时注意区分，由此造成的损失由您自行承担。<br>\
                  优惠活动与活动价</strong><br>\
                  1、我们可能会根据业务需求或市场需求，不定时调整产品价格，并在会员服务页面中向用户公示。除双方在相应产品或服务开通自动续费功能前所明确约定的价格外，当在您自动续费过程中发生了续费价格变动，如果自动续费价格高于您初次购买的价格时，我们会获取您的同意。如果自动续费价格低于您初次购买时的价格，我们将直接扣除相应款项。<br>\
                  2、智能演讲教练内会员及支付页面中所展示的价格不为最终价格，请以苹果系统所展示的最终支付价格为准。<br>\
                  其他声明<br>\
                  本协议作为《智能演讲教练用户协议》的补充协议，如本协议与《智能演讲教练用户协议》存在冲突，以本协议为准，本协议未约定的内容按照《智能演讲教练用户协议》执行。";
    }else if(type == 5 ){
      this.title = '第三方信息共享清单';
      document.title = '第三方信息共享清单';
      this.text = '更新日期2025.4';
      this.txt = "1.为保障珍时相关功能的实现与应用安全稳定的运行，我们可能会接入由合作方提供的软件开发包（SDK）、应用程序接口（API）、应用程序插件代码或通过其他合作方式，以实现相关目的。<br>\
                  2.我们会对获取信息的合作方的代码进行严格的安全监测，以保护数据安全。<br>\
                  3.我们对接入的相关合作方在目录中列明<br>\
                  4.请注意，合作方的代码可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。<br>\
<br>\
                  一、第三方SDK目录<br>\
<br>\
                  Alipay（支付宝） SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：帮助用户在应用内使用支付宝<br>\
                  使用场景：在用户使用支付宝支付时使用<br>\
                  运营方：支付宝（中国）网络技术有限公司<br>\
                  收集个人信息类型：设备信息、网络设备硬件地址，网络信息，读取存储（相册，媒体和其他文件）权限，读取手机状态<br>\
                  隐私权政策链接：https://opendocs.alipay.com/open/54<br>\
<br>\
                  友盟统计分析SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：进行APP运营统计与分析K<br>\
                  使用场景：通过友盟统计收集个移动平台运营数据分析K<br>\
                  运营方：友盟同欣（北京）科技有限公司，北京锐讯灵通科技有限公司K<br>\
                  收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OAID/OpenUDID/GUID/SIM卡IMSI/ICCID）、位置信息、网络信息。读取存储（相册，媒体和其他文件）权限K<br>\
                  隐私权政策链接：https://www.umeng.com/page/policyK<br>\
<br>\
                  微信 SDK<br>\
                  共享方式：SDK本机采集<br>\
                  使用目的：支持微信登录，微信分享，微信支付<br>\
                  使用场景：使用微信授权登录场景，微信分享和支付场景<br>\
                  运营方：深圳市腾讯计算机系统有限公司<br>\
                  收集个人信息类型：设备信息、网络设备硬件地址，网络信息，读取存储（相册，媒体和其他文件）权限，读取手机状态<br>\
                  隐私权政策链接：https://open.weixin.qq.com/cgj-bin/frame?t=news/protocol_developer_tmpl<br>\
<br>\
                  华为推送<br>\
                  运营方：华为软件技术有限公司 <br>\
                  功能：用于向华为手机用户推送消息 <br>\
                  收集个人信息类型: 设备信息（AndroidID）、运营商类型、本应用运行中的进程<br>\
                  隐私政策链接：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177<br>\
<br>\
                  小米推送<br>\
                  运营方：北京小米移动软件有限公司 <br>\
                  功能：用于向小米手机用户推送消息 <br>\
                  收集个人信息类型：设备信息（AndroidID、OAID）、本应用运行中的进程 <br>\
                  隐私政策链接：https://dev.mi.com/console/doc/detail?pId=1822<br>\
<br>\
                  VIVO推送<br>\
                  运营方：维沃移动通信有限公司 <br>\
                  功能：用于向VIVO手机用户推送消息 <br>\
                  收集个人信息类型：本应用运行中的进程 <br>\
                  隐私政策链接：https://dev.vivo.com.cn/documentCenter/doc/652<br>\
<br>\
                  支付宝<br>\
                  运营方：支付宝（中国）网络技术有限公司 <br>\
                  功能：可帮助用户完成付款、提供安全认证服务 <br>\
                  收集个人信息类型：设备信息（AndroidID）、蓝牙的mac地址、位置信息、剪切板信息、运营商类型、本应用运行中的进程 <br>\
                  隐私政策链接：https://render.alipay.com/p/c/k2cx0tg8<br>\
<br>\
                  高德地图<br>\
                  运营方：高德软件有限公司 <br>\
                  功能：帮助用户在发布信息时定位位置 <br>\
                  收集个人信息类型：位置信息（经纬度、精确位置、粗略位置）、设备信息【如IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（ OAID、IDFA）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统）<br>\
                  隐私政策链接：https://lbs.amap.com/pages/privacy_no_device_id<br>\
<br>\
                  魅族推送<br>\
                  运营方：珠海市魅族通讯设备有限公司 <br>\
                  功能：用于向魅族手机用户推送消息 <br>\
                  收集个人信息类型：运营商类型、本应用运行中的进程<br>\
                  隐私政策链接：http://static.meizu.com/resources/term/privacy8.html<br>\
<br>\
                  新浪微博sso授权 <br>\
                  运营方：北京微梦创科网络技术有限公司<br>\
                  功能：用于帮助用户进行授权登录及将信息分享至微博<br>\
                  收集个人信息类型：本应用运行中的进程<br>\
                  隐私政策链接：https://weibo.com/signup/v5/privacy<br>\
<br>\
                  阿里安全<br>\
                  运营方：杭州橙盾信息科技有限公司<br>\
                  功能：用于App运行、网络请求、账号注册及登录等安全防护。为了判断模拟点击攻击，采集设备传感器信息感知用户手机震动状态。<br>\
                  收集个人信息类型：IDFA、OAID、操作系统、设备传感器（设备加速器，如重力感应器）<br>\
                  隐私权政策链接：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_alibaba_group/suit_bu1_alibaba_group202101081802_49105.html<br>\
<br>\
                  号码认证 <br>\
                  运营方：阿里巴巴云计算（北京）有限公司<br>\
                  功能：实现本机号码一键登录和认证 <br>\
                  收集个人信息类型：网络类型、切换wifi和蜂窝网络通道、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM State）。<br>\
                  隐私权政策链接：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html<br>\
                  号码认证SDK服务集成三大运营商用户本机号码认证及一键登录及技术服务SDK，三大运营商如何处理用户个人信息，详见如下及隐私政策。<br>\
<br>\
                  中国移动 <br>\
                  运营主体:中国移动通信集团有限公司<br>\
                  功能:识别用户的手机号码快速登录，以及查询、分析和风险控制。<br>\
                  收集个人信息类型:网络类型、网络地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商。<br>\
                  隐私权政策链接:https://wap.cmpassport.com/resources/html/contract2.html<br>\
<br>\
                  中国联通 <br>\
                  运营主体:中国联合网络通信集团有限公司 <br>\
                  功能:识别用户的手机号码快速登录，以及实现业务风控<br>\
                  收集个人信息类型:网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商。<br>\
                  隐私政策链接:<br>\
                  https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true<br>\
<br>\
                  中国电信<br>\
                  运营主体:中国电信集团有限公司 <br>\
                  功能:识别用户的手机号码快速登录，以及实现业务风控<br>\
                  收集个人信息类型:网络IP地址、网络类型、注册手机号码、本机号码、国际移动用户标识码、应用进程信息、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本。<br>\
                  隐私政策链接:<br>\
                  https://e.189.cn/sdk/agreement/detail.do?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&appKey=E_189&hidetop=true&returnUrl=<br>\
<br>\
                  银联云闪付SDK<br>\
                  运营方：中国银联股份有限公司<br>\
                  功能：帮助用户使用云闪付支付渠道完成付款<br>\
                  收集个人信息类型：设备型号、App安装信息（只读云闪付App）<br>\
                  隐私政策链接：https://wallet.95516.com/s/wl/WebAPP/helpAgree/page/agreement/regPrivacy.html?cntryCode=86<br>\
<br>\
                  数典UT SDK<br>\
                  运营方：杭州数典科技有限公司<br>\
                  功能：统计分析<br>\
                  收集个人信息类型：设备信息（IDFA、AndroidID、OAID、GAID、client IP）、UT SDK存储于SD卡的配置信息<br>\
                  隐私权政策链接：https://terms.alicdn.com/legal-agreement/terms/suit_bu1_alibaba_group/suit_bu1_alibaba_group202110291512_80686.html";
    }
    this.font_resize();
  },
  methods: {
    font_resize(){
      var size=document.documentElement.clientWidth / 750 * 100;
      document.querySelector('html').style.fontSize=size + 'px';
    }
  }  
};
</script>
<style scoped>
  .contentBox{
    font-size: .2rem;
    color: #333;
    box-sizing: border-box;
    padding: .1rem .2rem;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .contentBox .title{
    font-size: .4rem;
    color: #333;
    font-weight: bold;
    margin: .2rem 0;
  }

  .contentBox .text{
    font-size: .3rem;
    color: #333;
    font-weight: bold;
    margin: 0 0 .2rem;
  }

  .contentBox>>> .blod{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/mobile/agreement.vue